// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.custom-textarea[data-v-39bd654c] {
  /* iOS Safari detection */
  width: 100%;
  height: 100%;
  color: var(--custom-textarea-color);
  white-space: pre-wrap;
  outline: none;
  border: none;
  overflow: hidden;
  line-height: 1.3em;
  min-height: 1em;
}
@supports (-webkit-touch-callout: none) {
.custom-textarea[data-v-39bd654c] {
    font-size: clamp(16px, var(--messageFontSize), 48px);
}
}
.custom-textarea-wrapper[data-v-39bd654c] {
  width: 100%;
  min-height: 20px;
  display: flex;
  max-height: 120px;
  overflow-y: auto;
  word-break: break-word;
  word-wrap: anywhere;
}
.custom-textarea-placeholder[data-v-39bd654c] {
  color: var(--placeholder-color);
  position: absolute;
  pointer-events: none;
  overflow: hidden;
  align-items: baseline;
  display: flex;
  line-height: 1.3em;
  font-size: var(--messageFontSize);
}
.message-send-block .disable-btn[data-v-39bd654c] {
  padding-top: 1px;
}
.message-send-block .disable-btn i[data-v-39bd654c] {
  color: var(--toolbtn-color-hover);
}
.textFormatter[data-v-39bd654c] {
  width: auto;
  height: 30px;
  background-color: var(--search-input-bgcolor);
  position: absolute;
  display: flex;
  flex-direction: row;
  align-items: center;
  opacity: 1;
  transition: background-color 0.5s ease-out, opacity 0.5s ease-out;
}
.textFormatter.hidden[data-v-39bd654c] {
  opacity: 0;
}
.textFormatter .tfbuttons[data-v-39bd654c] {
  width: auto;
  color: var(--font-color);
  align-self: center;
}
.textFormatter .tfbuttons .fal[data-v-39bd654c] {
  font-weight: 500;
}
.textFormatterdivider[data-v-39bd654c] {
  width: 1px;
  height: 1.75rem;
  margin: 0 0.25rem;
  background-color: var(--border-top-input);
}
.textFormatter .tfbutton[data-v-39bd654c] {
  width: 2.8rem;
  height: 2.8rem;
  padding: 0.15rem;
  font-size: 1.5rem;
  margin: 0 0.125rem;
  border-radius: 4px;
  flex-shrink: 0;
  background-color: var(--icon-btn-with-bg);
  border-width: 1px;
  border-color: var(--border-bottom-section);
  cursor: pointer;
}
.textFormatter .tfbutton[data-v-39bd654c]:hover,
.textFormatter .tfbutton[data-v-39bd654c]:focus {
  background-color: var(--icon-btn-hover);
  color: var(--font-color);
}
`, "",{"version":3,"sources":["webpack://./js/app/components/custom/CustomTextarea.vue"],"names":[],"mappings":"AAAA;EACE,yBAAyB;EACzB,WAAW;EACX,YAAY;EACZ,mCAAmC;EACnC,qBAAqB;EACrB,aAAa;EACb,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;AACjB;AACA;AACA;IACI,oDAAoD;AACxD;AACA;AACA;EACE,WAAW;EACX,gBAAgB;EAChB,aAAa;EACb,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,mBAAmB;AACrB;AACA;EACE,+BAA+B;EAC/B,kBAAkB;EAClB,oBAAoB;EACpB,gBAAgB;EAChB,qBAAqB;EACrB,aAAa;EACb,kBAAkB;EAClB,iCAAiC;AACnC;AACA;EACE,gBAAgB;AAClB;AACA;EACE,iCAAiC;AACnC;AACA;EACE,WAAW;EACX,YAAY;EACZ,6CAA6C;EAC7C,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,UAAU;EACV,iEAAiE;AACnE;AACA;EACE,UAAU;AACZ;AACA;EACE,WAAW;EACX,wBAAwB;EACxB,kBAAkB;AACpB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,UAAU;EACV,eAAe;EACf,iBAAiB;EACjB,yCAAyC;AAC3C;AACA;EACE,aAAa;EACb,cAAc;EACd,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;EACd,yCAAyC;EACzC,iBAAiB;EACjB,0CAA0C;EAC1C,eAAe;AACjB;AACA;;EAEE,uCAAuC;EACvC,wBAAwB;AAC1B","sourcesContent":[".custom-textarea[data-v-39bd654c] {\n  /* iOS Safari detection */\n  width: 100%;\n  height: 100%;\n  color: var(--custom-textarea-color);\n  white-space: pre-wrap;\n  outline: none;\n  border: none;\n  overflow: hidden;\n  line-height: 1.3em;\n  min-height: 1em;\n}\n@supports (-webkit-touch-callout: none) {\n.custom-textarea[data-v-39bd654c] {\n    font-size: clamp(16px, var(--messageFontSize), 48px);\n}\n}\n.custom-textarea-wrapper[data-v-39bd654c] {\n  width: 100%;\n  min-height: 20px;\n  display: flex;\n  max-height: 120px;\n  overflow-y: auto;\n  word-break: break-word;\n  word-wrap: anywhere;\n}\n.custom-textarea-placeholder[data-v-39bd654c] {\n  color: var(--placeholder-color);\n  position: absolute;\n  pointer-events: none;\n  overflow: hidden;\n  align-items: baseline;\n  display: flex;\n  line-height: 1.3em;\n  font-size: var(--messageFontSize);\n}\n.message-send-block .disable-btn[data-v-39bd654c] {\n  padding-top: 1px;\n}\n.message-send-block .disable-btn i[data-v-39bd654c] {\n  color: var(--toolbtn-color-hover);\n}\n.textFormatter[data-v-39bd654c] {\n  width: auto;\n  height: 30px;\n  background-color: var(--search-input-bgcolor);\n  position: absolute;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  opacity: 1;\n  transition: background-color 0.5s ease-out, opacity 0.5s ease-out;\n}\n.textFormatter.hidden[data-v-39bd654c] {\n  opacity: 0;\n}\n.textFormatter .tfbuttons[data-v-39bd654c] {\n  width: auto;\n  color: var(--font-color);\n  align-self: center;\n}\n.textFormatter .tfbuttons .fal[data-v-39bd654c] {\n  font-weight: 500;\n}\n.textFormatterdivider[data-v-39bd654c] {\n  width: 1px;\n  height: 1.75rem;\n  margin: 0 0.25rem;\n  background-color: var(--border-top-input);\n}\n.textFormatter .tfbutton[data-v-39bd654c] {\n  width: 2.8rem;\n  height: 2.8rem;\n  padding: 0.15rem;\n  font-size: 1.5rem;\n  margin: 0 0.125rem;\n  border-radius: 4px;\n  flex-shrink: 0;\n  background-color: var(--icon-btn-with-bg);\n  border-width: 1px;\n  border-color: var(--border-bottom-section);\n  cursor: pointer;\n}\n.textFormatter .tfbutton[data-v-39bd654c]:hover,\n.textFormatter .tfbutton[data-v-39bd654c]:focus {\n  background-color: var(--icon-btn-hover);\n  color: var(--font-color);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
